const state = {
    isSidebarCollapsed: false,
    theme: localStorage.getItem('theme') || 'dark',
};

const mutations = {
    TOGGLE_SIDEBAR(state) {
        state.isSidebarCollapsed = !state.isSidebarCollapsed;
    },
    TOGGLE_THEME(state) {
        state.theme = state.theme === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', state.theme);
        localStorage.setItem('theme', state.theme);
    }
};

const actions = {
    toggleSidebar({ commit }) {
        commit('TOGGLE_SIDEBAR');
    },
    toggleTheme({ commit }) {
        commit('TOGGLE_THEME');
    },
    initTheme({ state }) {
        document.documentElement.setAttribute('data-theme', state.theme);
    }
};

const getters = {
    isSidebarCollapsed: (state) => state.isSidebarCollapsed,
    theme: (state) => state.theme,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
